import { InjectionToken } from '@angular/core';

export const NOTIFICATION_TOKEN = new InjectionToken('Appo Notification Service');
export const PUSH_NOTIFICATION_TOKEN = new InjectionToken('Appo Push Notification Service');
export const LOCAL_NOTIFICATION_TOKEN = new InjectionToken('Appo Local Notification Service');
